var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdditionToPpe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7875 21.8025H11.8125V17.4488H16.2V15.4238H11.8125V11.0363H9.7875V15.4238H5.4V17.4488H9.7875V21.8025ZM19.575 27H2.025C1.485 27 1.0125 26.7975 0.6075 26.3925C0.2025 25.9875 0 25.515 0 24.975V2.025C0 1.485 0.2025 1.0125 0.6075 0.6075C1.0125 0.2025 1.485 0 2.025 0H14.2087L21.6 7.39125V24.975C21.6 25.515 21.3975 25.9875 20.9925 26.3925C20.5875 26.7975 20.115 27 19.575 27ZM13.1962 8.3025V2.025H2.025V24.975H19.575V8.3025H13.1962ZM2.025 2.025V8.3025V2.025V8.3025V24.975V2.025Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditionToPpe);
export default __webpack_public_path__ + "static/media/addition_to_ppe.8cee96de345ee065f54babb1df72d17c.svg";
export { ForwardRef as ReactComponent };